import { render, staticRenderFns } from "./LaborActions.vue?vue&type=template&id=7b255d34&"
import script from "./LaborActions.vue?vue&type=script&lang=js&"
export * from "./LaborActions.vue?vue&type=script&lang=js&"
import style0 from "./LaborActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports